import styles from "./styles.module.scss";
import img1 from './img/img1.png'
import img2 from './img/img2.png'
import sofa from './img/sofa.png'

import { IconCard } from "../../../../shared";
import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "STRONG", // ?
    displayValue: "No, I move a lot during my day",
    emoji: img2
  },
  {
    value: "WEAK",
    displayValue: "Yes, I spend a lot of time seated",
    emoji: img1  },
];
export const SedentaryLifestyle = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.sedentaryLifestyle, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Do you have a sedentary lifestyle?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
      <img src={sofa} alt=''/>
    </div>
  );
};
